<!-- 圆环 -->
<template>
    <div class="cards">
        <div class="cards-item">
            <div class="cards-item-tit">{{cardsTit}}</div>
            <div class="cards-item-conter">
                <slot name="cardsConter"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        cardsTit:{
            default: '',
            type: String,
        },
    },
    components:{
    },
    data() {
        return {

        }
    },
    created() {

    },
    mounted() {

    }
}
</script>
<style lang="scss">
@import url('../assets/scss/cards.scss');
</style>